export default function OpenInSameTab(url) {
  globalThis.location.href = url;
}